import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddDesignation from "./addDesignation";
import GetAllDesignation from "./getAllDesignation";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { Col, Row } from "antd";

const Designation = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div>
			<PageTitle title="Back" />
			<Row gutter={16} className="mt-5">
				{/* Left Side - Add Designation */}
				<Col xs={14} sm={14} md={8} lg={8}>
					<UserPrivateComponent permission={"create-designation"}>
						<AddDesignation />
					</UserPrivateComponent>
				</Col>

				{/* Right Side - Designation List */}
				<Col xs={24} sm={24} md={16} lg={16} >
					<UserPrivateComponent permission={"readAll-designation"}>
						<GetAllDesignation />
					</UserPrivateComponent>
				</Col>
			</Row>
		</div>
	);
};

export default Designation;
